import { useEffect, useState } from "react";
import { EVENTS_CHANGED, getAllBookings, listInquiries } from "./eventsApi";

export type EventsIndicators = {
  /** Inquiries still in the pipeline's "New" column. */
  newInquiries: number;
  /** Calls with status "scheduled" whose time hasn't passed — the Upcoming tab. */
  scheduledCalls: number;
};

export function useEventsIndicators(enabled: boolean): EventsIndicators {
  const [newInquiries, setNewInquiries] = useState(0);
  const [scheduledCalls, setScheduledCalls] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const poll = () => {
      listInquiries({ status: "new", limit: 100 })
        .then((r) => { if (!cancelled) setNewInquiries(r.data.length); })
        .catch(() => {});
      getAllBookings("scheduled")
        .then((r) => {
          if (cancelled) return;
          const now = Date.now();
          setScheduledCalls(r.data.filter((b) => new Date(b.scheduled_at).getTime() >= now).length);
        })
        .catch(() => {});
    };
    poll();
    const id = setInterval(poll, 60_000);
    window.addEventListener(EVENTS_CHANGED, poll);
    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener(EVENTS_CHANGED, poll);
    };
  }, [enabled]);

  return { newInquiries, scheduledCalls };
}
